const searchInput = document.querySelector("#searchfaq")
const searchButton = document.querySelector(".btn-search")

let timeout = 0


if(searchButton)
  searchButton.addEventListener("click", function (e) {
    track("FAQ", "Search CTA Clicked", {valueSearched: searchInput.value})
  })
if(searchInput)
  searchInput.addEventListener("keyup", function (e) {
    if (e.keyCode === 13) {
      e.stopPropagation()
      track("FAQ", "Search Submitted", {valueSearched: searchInput.value})
    } else {
      clearTimeout(timeout)
      timeout = setTimeout(function () {
        track("FAQ", "Input Searched", {valueSearched: searchInput.value})
      }, 500)
    }
  })

function filterFaq(elm) {
  let searchTerm = searchInput.value.toLowerCase().trim() || ""
  const accordionItems = document.getElementsByClassName("accordion-item--faq")
  const categoryName = document.getElementsByClassName("category-item")
  const notFound = document.getElementById("notFound")
  const noAnswer = document.getElementById("noAnswer")
  const resultsContainer = document.getElementsByClassName("result-container")[0]

  // toggle category visibility based on searchTerm match
  for (i = 0; i < accordionItems.length; i++) {
    if (accordionItems[i].textContent.toLowerCase().includes(searchTerm)) {
      if (resultsContainer) {
        resultsContainer.style.display = "block"
      }
      accordionItems[i].style.display = "block"
    } else {
      accordionItems[i].style.cssText = "display: none !important;"
    }
  }

  for (i = 0; i < categoryName.length; i++) {
    const dataAttribute = categoryName[i].getAttribute("data-category")

    if (categoryName[i].textContent.toLowerCase().includes(searchTerm)) {
      categoryName[i].style.display = "block"
      setButtonStyle(dataAttribute, "display: block !important;")
    } else {
      categoryName[i].style.cssText = "display: none !important;"
      setButtonStyle(dataAttribute, "display: none !important;")
    }
  }

  const visibleCategories = $(".category-item:visible")
  console.log(visibleCategories.length)
  if (visibleCategories.length == 0) {
    notFound.style.display = "block"
    track("FAQ", "No Result Displayed", {valueSearched: searchInput.value})

    if (resultsContainer) {
      resultsContainer.style.display = "none"
    }
    if (noAnswer) {
      noAnswer.style.display = "none"
    }
  } else {
    notFound.style.display = "none"
    if (noAnswer) {
      noAnswer.style.display = "block"
    }
  }

  const visibleAccordions = $(".accordion-item--faq:visible")
  const messageResults = document.getElementById("messageResults")
  if (searchTerm.length) {
    messageResults.style.cssText = "display: block !important;"
    if (visibleAccordions) {
      const counterContainer = document.getElementById("counterResults")
      const matchCount = visibleAccordions.length
      counterContainer.textContent = matchCount
      if (matchCount === 1) {
        $("#resultsTextSingular").css("display", "initial")
        $("#resultsTextPlural").css("display", "none")
      } else {
        $("#resultsTextPlural").css("display", "initial")
        $("#resultsTextSingular").css("display", "none")
      }
    }
  } else {
    messageResults.style.display = "none"
  }
}

function setButtonStyle(attributeName, styleText) {
  const selector = `[data-category='${attributeName}']`
  const buttonList = (document.getElementById("filter-options").querySelectorAll(selector)[0].parentNode.style.cssText = styleText)
}

let counter = 0
function add(name) {
  if (!name.trim()) {
    return
  }

  const filterButtons = document.getElementById("filter-options")
  if (filterButtons) {
    const element = document.createElement("a")

    element.setAttribute("role", "button")
    element.setAttribute("data-category", name)
    element.setAttribute("name", name)
    element.setAttribute("id", counter)
    element.textContent = name
    element.setAttribute("class", "btn-option cta cta--small text-uppercase text-lg-center text-md-start")

    const li = document.createElement("li")
    li.setAttribute("class", "option-container")

    li.appendChild(element)
    filterButtons.appendChild(li)
    counter++
    console.log(name)
    return
  }
}

window.addEventListener("load", (ee) => {
  $("#contentFilter > li").each(function (index, elm) {
    add($(elm).attr("data-category"))
  })

  $(".faq-container .btn-option").on("click", (event) => {
    const mainSelector = ".category-item"
    const tagCategory = $(event.target).data("category")
    const idCategory = $(event.target).attr("id")
    const searchInput = document.getElementById("searchfaq")

    if (tagCategory) {
      $(mainSelector).css({display: "none"})
      $(`${mainSelector}[data-category="${tagCategory}"]`).css({
        display: "list-item",
        marginTop: 0,
      })
    }
    if (tagCategory === "all") {
      $(mainSelector).css({display: "list-item", marginTop: ""})
      searchInput.value = ""
      filterFaq()
    }

    $(`.faq-container .btn-option`).toggleClass("btn-option__selected", false)
    $(`.faq-container .btn-option`).parent(".option-container").toggleClass("option-container__selected", false)
    $(`.faq-container #${idCategory}`).toggleClass("btn-option__selected")
    $(`.faq-container [data-category='${tagCategory}']`).parent(".option-container").toggleClass("option-container__selected")

    $('.cards-container .category-item').each(function () {
      //Searching for each category title to find global title text
      let selectedCategoryName = $('.option-container.option-container__selected').find('a').first().html()
      let categoryName = $(this).first().find('h1,h2,h3,h4,h5,h6').first().html()
      if (categoryName == selectedCategoryName) {
        let globalSectionTitle = $(this).attr('data-tracker-text')
        track('FAQ', `Filter ${globalSectionTitle} Selected`)
      }
    })
  })
})

window.filterFaq = filterFaq
